import {BoxLite} from '../../../common/types/box'
import {CompartmentLite, CompartmentProduct} from '../../../common/types/compartment'
import {GQL_ContractType} from '../../../generated/graphql'

export interface CompartmentsThatNeedsActionData {
  id: string
  box: BoxLite
  compartment: CompartmentLite
  contractType?: GQL_ContractType | null
  date?: string
  locked: boolean
  organisationId?: string
  product?: CompartmentProduct
  productStatus?: CompartmentProduct['productStatus']
}

export const createCompartmentsThatNeedsActionData = (boxes: BoxLite[]): CompartmentsThatNeedsActionData[] => {
  const rows: CompartmentsThatNeedsActionData[] = []

  boxes
    .filter((box: BoxLite) => box.active)
    .forEach((box: BoxLite) => {
      box.compartments
        .filter((compartment: CompartmentLite) => !compartment.private)
        .forEach((compartment: CompartmentLite) => {
          if (compartment.locked || !compartment.product || compartment.product.productStatus !== 'Ok') {
            rows.push({
              id: box.id + compartment.id,
              box,
              compartment,
              contractType: box.contractType ?? null,
              date: compartment.ongoingRental?.rentStart ?? '',
              locked: compartment.locked,
              product: compartment.product,
              productStatus: compartment.product?.productStatus,
            })
          }
        })
    })

  return rows
}
